import { type Status, type StatusConfig } from './types';

export const statusConfig: Record<Status, StatusConfig> = {
    in_progress: {
        label: 'Em Andamento',
        color: 'bg-info/10 text-info border-info/20',
    },
    completed: {
        label: 'Concluído',
        color: 'bg-green-100 text-green-700 border-green-300',
    },
};
